import { AppThunk } from 'store';
import { batch } from 'react-redux';
import { cardsAPI } from 'entities/cards';
import{ StatusLoading } from 'common/constants';
import { getResponseError } from 'common/utils/index';
import { OrderSecondStepOptions } from 'entities/cards';

import slice from '../reducer/slice';
import { applicationActions } from 'entities/application';

const { setIsLoadingSecondStep, setSecondStep } = slice.actions;
const { setErrorNotice } = applicationActions;

type TOperation = (data: OrderSecondStepOptions) => AppThunk;

const operation: TOperation = (data) => async (dispatch: any) => {
  try {
    dispatch(setIsLoadingSecondStep(StatusLoading.Load));

    const { data: result } = await cardsAPI.orderSecondStep(data);

    batch(() => {
      dispatch(setIsLoadingSecondStep(StatusLoading.Done));
      dispatch(setSecondStep({...result, cardCount: data.cardCount, prePay: data.prePay }));
    });
  } catch (e) {
    const error = await getResponseError(e);
    batch(() => {
      dispatch(setErrorNotice(error));
      dispatch(setIsLoadingSecondStep(StatusLoading.Error));
    });
  }
};

export default operation;
